var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M116.184 69.7131C119.295 69.7131 121.817 67.1332 121.817 63.9508C121.817 60.7684 119.295 58.1885 116.184 58.1885C113.073 58.1885 110.551 60.7684 110.551 63.9508C110.551 67.1332 113.073 69.7131 116.184 69.7131Z",
  fill: "#FDDA01"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M446.598 49.4357C449.709 49.4357 452.231 46.8558 452.231 43.6734C452.231 40.491 449.709 37.9112 446.598 37.9112C443.487 37.9112 440.965 40.491 440.965 43.6734C440.965 46.8558 443.487 49.4357 446.598 49.4357Z",
  fill: "#FDDA01"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.817 24.8083C7.47737 24.8083 9.63404 22.6021 9.63404 19.8806C9.63404 17.1591 7.47737 14.9529 4.817 14.9529C2.15664 14.9529 0 17.1591 0 19.8806C0 22.6021 2.15664 24.8083 4.817 24.8083Z",
  fill: "#FDDA01"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M315.695 180.906C318.806 180.906 321.328 178.326 321.328 175.144C321.328 171.962 318.806 169.382 315.695 169.382C312.584 169.382 310.062 171.962 310.062 175.144C310.062 178.326 312.584 180.906 315.695 180.906Z",
  fill: "#FDDA01"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M112.194 141.931C114.462 141.931 116.301 140.05 116.301 137.73C116.301 135.41 114.462 133.529 112.194 133.529C109.927 133.529 108.088 135.41 108.088 137.73C108.088 140.05 109.927 141.931 112.194 141.931Z",
  fill: "#FDDA01"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M300.195 164.096C301.654 164.096 302.837 162.887 302.837 161.394C302.837 159.902 301.654 158.692 300.195 158.692C298.736 158.692 297.554 159.902 297.554 161.394C297.554 162.887 298.736 164.096 300.195 164.096Z",
  fill: "#FDDA01"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M580.693 182.532C582.152 182.532 583.334 181.323 583.334 179.83C583.334 178.338 582.152 177.128 580.693 177.128C579.234 177.128 578.051 178.338 578.051 179.83C578.051 181.323 579.234 182.532 580.693 182.532Z",
  fill: "#FDDA01",
  fillOpacity: 0.7
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1237.45 40.7442C1239.83 40.7442 1241.76 38.7693 1241.76 36.3331C1241.76 33.8969 1239.83 31.922 1237.45 31.922C1235.07 31.922 1233.14 33.8969 1233.14 36.3331C1233.14 38.7693 1235.07 40.7442 1237.45 40.7442Z",
  fill: "#FDDA01"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1376.85 195.533C1378.31 195.533 1379.49 194.323 1379.49 192.831C1379.49 191.338 1378.31 190.128 1376.85 190.128C1375.39 190.128 1374.21 191.338 1374.21 192.831C1374.21 194.323 1375.39 195.533 1376.85 195.533Z",
  fill: "#FDDA01"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1402.37 248.268C1403.83 248.268 1405.02 247.058 1405.02 245.565C1405.02 244.073 1403.83 242.863 1402.37 242.863C1400.91 242.863 1399.73 244.073 1399.73 245.565C1399.73 247.058 1400.91 248.268 1402.37 248.268Z",
  fill: "#FDDA01",
  fillOpacity: 0.7
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M865.124 55.425C868.235 55.425 870.757 52.8451 870.757 49.6627C870.757 46.4802 868.235 43.9003 865.124 43.9003C862.013 43.9003 859.491 46.4802 859.491 49.6627C859.491 52.8451 862.013 55.425 865.124 55.425Z",
  fill: "#FDDA01"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1559.74 114.318C1562.85 114.318 1565.37 111.738 1565.37 108.556C1565.37 105.373 1562.85 102.793 1559.74 102.793C1556.63 102.793 1554.11 105.373 1554.11 108.556C1554.11 111.738 1556.63 114.318 1559.74 114.318Z",
  fill: "#FDDA01"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1587.69 10.7988C1590.07 10.7988 1592 8.82384 1592 6.38762C1592 3.95139 1590.07 1.97644 1587.69 1.97644C1585.31 1.97644 1583.38 3.95139 1583.38 6.38762C1583.38 8.82384 1585.31 10.7988 1587.69 10.7988Z",
  fill: "#FDDA01"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M759.696 6.38279C761.155 6.38279 762.338 5.1729 762.338 3.68047C762.338 2.18804 761.155 0.97821 759.696 0.97821C758.237 0.97821 757.055 2.18804 757.055 3.68047C757.055 5.1729 758.237 6.38279 759.696 6.38279Z",
  fill: "#FDDA01"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M583.888 78.3523C586.053 78.3523 587.807 76.5573 587.807 74.3431C587.807 72.1289 586.053 70.334 583.888 70.334C581.724 70.334 579.969 72.1289 579.969 74.3431C579.969 76.5573 581.724 78.3523 583.888 78.3523Z",
  fill: "#FDDA01"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M430.721 126.265C432.886 126.265 434.64 124.47 434.64 122.256C434.64 120.042 432.886 118.247 430.721 118.247C428.557 118.247 426.802 120.042 426.802 122.256C426.802 124.47 428.557 126.265 430.721 126.265Z",
  fill: "#FDDA01"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M219.02 73.2165C220.567 73.2165 221.82 71.9341 221.82 70.3523C221.82 68.7704 220.567 67.4881 219.02 67.4881C217.474 67.4881 216.221 68.7704 216.221 70.3523C216.221 71.9341 217.474 73.2165 219.02 73.2165Z",
  fill: "#FDDA01"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1324.85 211.717C1328.14 211.717 1330.82 208.981 1330.82 205.607C1330.82 202.232 1328.14 199.496 1324.85 199.496C1321.55 199.496 1318.87 202.232 1318.87 205.607C1318.87 208.981 1321.55 211.717 1324.85 211.717Z",
  fill: "#FDDA01"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M1087.78 124.875C1091.08 124.875 1093.75 122.139 1093.75 118.764C1093.75 115.39 1091.08 112.654 1087.78 112.654C1084.48 112.654 1081.81 115.39 1081.81 118.764C1081.81 122.139 1084.48 124.875 1087.78 124.875Z",
  fill: "#FDDA01"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M1404.36 180.784C1406.31 180.784 1407.9 179.16 1407.9 177.157C1407.9 175.153 1406.31 173.529 1404.36 173.529C1402.4 173.529 1400.81 175.153 1400.81 177.157C1400.81 179.16 1402.4 180.784 1404.36 180.784Z",
  fill: "#FDDA01"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M267.798 248.529C269.684 248.529 271.213 246.964 271.213 245.035C271.213 243.105 269.684 241.541 267.798 241.541C265.913 241.541 264.384 243.105 264.384 245.035C264.384 246.964 265.913 248.529 267.798 248.529Z",
  fill: "#FDDA01",
  fillOpacity: 0.45
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M1413.62 22.161C1415.89 22.161 1417.73 20.2802 1417.73 17.9602C1417.73 15.6401 1415.89 13.7593 1413.62 13.7593C1411.36 13.7593 1409.52 15.6401 1409.52 17.9602C1409.52 20.2802 1411.36 22.161 1413.62 22.161Z",
  fill: "#FDDA01"
});

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1592,
    height: 249,
    viewBox: "0 0 1592 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref3), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref5), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref6)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref7), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref8), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref9), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref10), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref11), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref12), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref13), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref14), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref15), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref16), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref17), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref18), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref19)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref20), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref21), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref22), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref23));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.38ee12b9ad4bb19af1a4944f84b4bb6a.svg";
export { ForwardRef as ReactComponent };